import z from "zod";

const envSchema = z.object({
  NODE_ENV: z.enum(["production", "development", "test"]),
  RUN_ENV: z.enum(["production", "staging", "development", "demo", "test"]),
  BRANCH_NAME: z.string().optional(),
  COMMIT_SHA: z.string().optional(),
});

// The environment variables are baked into the JavaScript bundle during building
// so we need to create our own object. We can't use "process.env" as a parameter
// when calling Zod's safeParse().
// All env variables other than NODE_ENV must be prefixed with PUBLIC_,
// See https://rsbuild.rs/guide/advanced/env-vars
const parsedEnv = envSchema.safeParse({
  NODE_ENV: process.env.NODE_ENV,
  RUN_ENV: getRunEnv(),
  BRANCH_NAME: process.env.PUBLIC_BRANCH_NAME !== "" ? process.env.PUBLIC_BRANCH_NAME : undefined,
  COMMIT_SHA: process.env.PUBLIC_COMMIT_SHA !== "" ? process.env.PUBLIC_COMMIT_SHA : undefined,
});

// Determine the correct "RUN_ENV" environment variable.
// When starting a production build in staging we want this to be "staging",
// but if the build was built with the environment variable set to "production"
// that value would be inlined into the JavaScript bundle
// so we have to check the hostname to find out.
function getRunEnv() {
  if (process.env.NODE_ENV === "production") {
    if (window.location.hostname.endsWith("alice-bob.no")) {
      return "production";
    }

    if (window.location.hostname.endsWith("staging.terralux.minus-data.no")) {
      return "staging";
    }

    if (window.location.hostname.endsWith("demo.terralux.minus-data.no")) {
      return "demo";
    }

    if (window.location.hostname.endsWith("localhost")) {
      return "development";
    }

    throw new Error("Invalid hostname");
  }

  if (process.env.NODE_ENV === "test") {
    return "test";
  }

  return "development";
}

if (parsedEnv.success === false) {
  throw new Error(`Error parsing environment variables: ${JSON.stringify(parsedEnv.error.issues)}`);
}

export const env = parsedEnv.data;
